import { TurnState } from '@colonist/game-states';
import { useGameStore } from '../GameStoreContext.ts';
import { useIsReplay } from './useIsReplay.ts';
export const useIsGameEnded = ()=>{
    const isReplay = useIsReplay();
    const turnState = useGameStore((state)=>state.gameState.currentState.turnState);
    if (isReplay) return true;
    return turnState === TurnState.GameEnd;
};
